import Section from "@/components/site/Section";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import { TIMELINE } from "@/lib/content";

export default function Timeline() {
  return (
    <Section bg="surface" data-testid="timeline">
      <Reveal className="max-w-3xl">
        <SectionHeading overline="An Illustrative Stop" title={<>What can you do while<br />your car charges?</>} />
      </Reveal>

      <div className="relative mt-14">
        <div className="absolute left-4 top-2 h-[calc(100%-1rem)] w-px bg-white/10 md:left-0 md:top-6 md:h-px md:w-full" />
        <div className="grid gap-8 md:grid-cols-5 md:gap-4">
          {TIMELINE.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.08} className="relative pl-12 md:pl-0 md:pt-14">
              <span className="absolute left-[9px] top-1 h-3.5 w-3.5 rounded-full border-2 border-rp-accent bg-rp-bg md:left-0 md:top-[18px]" />
              <span className="font-mono text-sm font-medium tracking-[0.14em] text-rp-accent">{s.t}</span>
              <h3 className="mt-2 font-display text-lg font-medium tracking-tight text-white">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-white/55">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <p className="mt-12 max-w-2xl font-mono text-[11px] leading-relaxed tracking-wide text-white/35">
        Illustrative RestPower stop experience. Actual charging time varies by vehicle, battery condition,
        charger capability, temperature, and state of charge.
      </p>
    </Section>
  );
}
